import { buildVectorizeColorsMap } from './buildDesignData';
import { parseSvgViewBox } from './svgDocument';
import { processSvgColorAreas } from './svgColorAreas';
import type { ColorOption } from './itemMetrics';
import type { ColorArea, ImageItem } from '../Reducers/Configurator/types';

export function buildProcessedImageUploadPatch(
  rawSvg: string,
  item: ImageItem,
  colorOptions: ColorOption[],
  imageData?: Record<string, unknown>
): Partial<ImageItem> | null {
  const fullViewBox = parseSvgViewBox(rawSvg, item.viewBoxWidth || 100, item.viewBoxHeight || 100);
  const mmPerUserUnitX = item.width > 0 ? item.width / fullViewBox.width : 1;
  const mmPerUserUnitY = item.height > 0 ? item.height / fullViewBox.height : 1;

  const processed = processSvgColorAreas(rawSvg, {
    mmPerUserUnitX,
    mmPerUserUnitY,
    colorOptions,
  });
  if (!processed) return null;

  const colorAreas = processed.colorAreas as ColorArea[];
  const vectorizeColorsMap = buildVectorizeColorsMap(colorAreas);

  return {
    svgSource: processed.svgSource,
    colorAreas,
    colorAreaBounds: processed.colorAreaBounds,
    ...(imageData || vectorizeColorsMap
      ? {
          imageData: {
            ...(imageData || {}),
            operations: {
              ...((imageData?.operations as Record<string, unknown>) || {}),
              vectorizeColorsMap,
            },
          },
        }
      : {}),
  };
}
